// extracted by mini-css-extract-plugin
module.exports = {"hero":"tag--hero--3ukZZ","posts":"tag--posts--303SN"};